import React from 'react';

const NomadIcon = () => (
  React.createElement('svg', {
    width: "22",
    height: "24",
    viewBox: "0 0 22 24"   ,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",}
  
    , React.createElement('path', {
      d: "M11.0034 0L0.604004 5.99911V18.0009L10.9963 24L21.3957 18.0009V5.99911L11.0034 0ZM15.6428 13.2045L12.8734 14.8033L9.52594 12.9725V16.7982L6.38185 18.7932V10.7991L8.87999 9.27167L12.3417 11.0953V7.19108L15.6428 5.20684V13.2045Z"            ,
      fill: "#00CA8E",}
    )
  )
);

export default NomadIcon;
